const CONFIRM_EMAIL = 'dofe-web/confirm-email/CONFIRM_EMAIL'
const CONFIRM_EMAIL_SUCCESS = 'dofe-web/confirm-email/CONFIRM_EMAIL_SUCCESS'
const CONFIRM_EMAIL_FAIL = 'dofe-web/confirm-email/CONFIRM_EMAIL_FAIL'

const ACCOUNT_REACTIVATION = 'dofe-web/confirm-email/ACCOUNT_REACTIVATION'
const ACCOUNT_REACTIVATION_SUCCESS = 'dofe-web/confirm-email/ACCOUNT_REACTIVATION_SUCCESS'
const ACCOUNT_REACTIVATION_FAIL = 'dofe-web/confirm-email/ACCOUNT_REACTIVATION_FAIL'

const initialState = {
  loading: false,
  loaded: false
}

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case CONFIRM_EMAIL:
      return {
        ...state,
        loading: true
      }
    case CONFIRM_EMAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true
      }
    case CONFIRM_EMAIL_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }
    case ACCOUNT_REACTIVATION:
      return {
        ...state,
        loading: true
      }
    case ACCOUNT_REACTIVATION_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true
      }
    case ACCOUNT_REACTIVATION_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }
    default:
      return state
  }
}

export function confirmEmail(code) {
  return {
    types: [CONFIRM_EMAIL, CONFIRM_EMAIL_SUCCESS, CONFIRM_EMAIL_FAIL],
    promise: client =>
      client.post(`api/email-confirmations?authorizationCode=${code}`, {
        removeToken: true,
        unauthorizedAction: false
      })
  }
}

export function reactivateAccount(code) {
  return {
    types: [ACCOUNT_REACTIVATION, ACCOUNT_REACTIVATION_SUCCESS, ACCOUNT_REACTIVATION_FAIL],
    promise: client =>
      client.post(`api/participants/re-activation?authorizationCode=${code}`, {
        removeToken: true,
        unauthorizedAction: false
      })
  }
}

export function organizationContactReactivateAccount(code) {
  return {
    types: [ACCOUNT_REACTIVATION, ACCOUNT_REACTIVATION_SUCCESS, ACCOUNT_REACTIVATION_FAIL],
    promise: client =>
      client.post(`api/persons/re-activation?authorizationCode=${code}`, {
        removeToken: true,
        unauthorizedAction: false
      })
  }
}

